import {
  TileArcGISRest,
  TileWMS,
} from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { getStandardLayerProps } from './utils'

export function createWmsLayer(config) {
  let source

  const sourceContent = {
    ...config.source,
    url: config.url,
    params: {
      ...(config.source?.params || {}),
      LAYERS: config.layers,
    },
  }

  switch (config.type) {
    case 'wms':
      source = new TileWMS(sourceContent)
      break

    case 'arcgisrest':
      source = new TileArcGISRest(sourceContent)
      break
  }

  return new TileLayer({
    ...getStandardLayerProps(config),
    source,
  })
}
